import React from "react";
import { EconomicReleaseCalendar } from "../release-intelligence";

export default function EconomicsCalendarScreen():JSX.Element{return <>
  <header className="economics-route-hero"><span>CALENDAR</span><h1>Know when the picture changes.</h1><p>Release timing explains why mixed-frequency indicators do not share one observation date.</p></header>
  <EconomicReleaseCalendar/>
</>}
